import styles from "./EmailHeader.module.css";

const EmailHeader = () => {
  return <span className={styles.headerTitle}>Confirm Email</span>
  } 
export default EmailHeader;